import React, { useState, useRef, useEffect } from "react";
import "../css/homeinsurance.css";
import homeinsuranceimg from "../assets/homeinsuranceimg.webp";
import tollfreenumberimg from "../assets/tollfreenumberimg.webp";
import PoliciesSlider from "../components/PolicyiesSlider";
import ConsultationForm from "../components/ConsultationForm";
import ChatbotAi from "../components/ChatbotAi";
import axios from "axios";
import { Helmet } from 'react-helmet-async';

const HomeInsurance = () => {
    const API_URL = process.env.REACT_APP_Dashboard_API_URL;
    const imageRefs = useRef([]);
    const imageSources = [
        homeinsuranceimg,
        tollfreenumberimg
    ];

    useEffect(() => {
        if (imageRefs.current.length > 0) {
            let index = 0;

            const showNextImage = () => {
                imageRefs.current.forEach((img, i) => {
                    if (img) img.style.display = i === index ? "block" : "none";
                });

                index++;
                if (index >= imageRefs.current.length) index = 0;
                setTimeout(showNextImage, 3000);
            };

            showNextImage();
        }
    }, []);

    const handleSubmit = async (data) => {
        const inquriyData = new FormData();
        inquriyData.append("Name", data.Name);
        inquriyData.append("Email", data.Email);
        inquriyData.append("PreferredDate", data.Date);
        inquriyData.append("PreferredTime", data.Time);
        inquriyData.append("MobileNo", data.MobileNo);
        inquriyData.append("Status", "New");
        inquriyData.append("UserId", data.Id);
        inquriyData.append("InquiryType", "Insurance Inquiries");
        inquriyData.append("PolicyType", "Home Insurance");
        inquriyData.append("IsLoggedIn", data.isLoggedIn);
        inquriyData.append("Otp", data.OTP);
        try {
            const response = await axios.post(`${API_URL}AddNewInquiries`, inquriyData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            return { status: response.status, data: response.data };
        } catch (error) {
            console.error("Error submitting consultation request:", error);
            return {
                status: 500,
                data: {
                    success: false,
                    message: error.response?.data?.message
                }
            };
        }
    };

    return (
        <div className="homeinsurance-container">
            <Helmet>
                <title>Home Insurance Explained | Protect Your Property Easily</title>
                <meta
                    name="description"
                    content="Understand home insurance with simple expert explanations. Learn how to safeguard your home and valuable possessions with confidence."
                />
                <meta
                    name="keywords"
                    content="home insurance explained, safeguard home insurance, property insurance India, home insurance expert advice, understand property coverage"
                />
                <link rel="canonical" href="https://policysamjho.com/home-insurance-explained/" />
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Service",
                        "name": "Home Insurance Explained",
                        "description": "Simple, clear explanations of home insurance policies. Learn how to safeguard your home and valuable possessions with the right coverage from Policy Samjho experts.",
                        "provider": {
                            "@type": "Organization",
                            "name": "Policy Samjho",
                            "url": "https://policysamjho.com/"
                        },
                        "serviceType": "Home Insurance Consultation",
                        "areaServed": "IN",
                        "url": "https://policysamjho.com/home-insurance-explained/",
                        "contactPoint": {
                            "@type": "ContactPoint",
                            "telephone": "+91-9584484800",
                            "email": "info@policysamjho.com",
                            "contactType": "customer service"
                        }
                    })}
                </script>
            </Helmet>

            <div className="homeinsurance-hero-container">
                <div className="homeinsurance-hero-text-box">
                    <h1>
                        <span style={{ color: '#192437' }}>Home Insurance </span>
                        <span style={{ color: '#F5A526' }}>Explained</span>
                    </h1>

                    <p style={{ color: "black", fontWeight: "600", fontSize: "18px", textAlign: 'justify' }}>
                        Your home is your biggest asset. Get clear, expert guidance on how to
                        safeguard your property and valuable possessions against unexpected risks.
                    </p>
                </div>

                <div className="homeinsurance-hero-image-box homeinsurance-imgslider">
                    {imageSources.map((image, index) => (
                        <img
                            key={index}
                            ref={(el) => (imageRefs.current[index] = el)}
                            src={image}
                            className="homeinsurance-sliderimg"
                            alt={`homeinsurance-slide-${index}`}
                            style={{ display: index === 0 ? "block" : "none" }}
                        />
                    ))}
                </div>
            </div>

            <div className="homeinsurance-containform-container">
                <div className="col-md-6 homeinsurance-info">
                    <h2 className="homeinsurance-heading">
                        <span style={{ color: '#192437' }}>What is </span>
                        <span style={{ color: '#F5A526' }}>Home Insurance?</span>
                    </h2>
                    <p className="homeinsurance-text">
                        Home insurance provides financial protection against loss or damage
                        to your property due to unforeseen circumstances like natural disasters,
                        fire, and theft. It helps homeowners recover financially in case of damage.
                    </p>

                    <h2 className="homeinsurance-subheading">
                        <span style={{ color: '#192437' }}>Why is Home </span>
                        <span style={{ color: '#F5A526' }}>Insurance Important?</span>
                    </h2>
                    <ul className="homeinsurance-benefits">
                        <li className="homepoints">Coverage for theft and burglary</li>
                        <li className="homepoints">Financial security in emergencies</li>
                        <li className="homepoints">Protection against property damage</li>
                        <li className="homepoints">Liability coverage for third-party damages</li>
                    </ul>

                    <h2 className="homeinsurance-subheading">
                        <span style={{ color: '#192437' }}>Comprehensive Coverage & </span>
                        <span style={{ color: '#F5A526' }}>Benefits Home Insurance</span>
                    </h2>
                    <p className="homeinsurance-text spaced-text">
                        Home insurance provides peace of mind by safeguarding your property against
                        unexpected damages and financial losses. Many policies include coverage for
                        natural disasters, theft, and liability protection, ensuring long-term security.
                        Additionally, certain plans offer added perks such as temporary housing coverage
                        and repair reimbursements, making it a smart investment for homeowners.
                    </p>
                </div>

                <div>
                    <h4 className="consultationform-heading">
                        <span style={{ color: "#192437" }}>Get a Free </span>
                        <span style={{ color: "#F5A526" }}>Home Insurance Consultation</span>
                    </h4>
                    <ConsultationForm onSubmit={handleSubmit} />
                </div>
            </div>
            <PoliciesSlider category="Home Insurance" />
            <ChatbotAi />
        </div>
    );
};

export default HomeInsurance;